'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberComplianceService = function () {
  function MemberComplianceService($http) {
    'ngInject';

    _classCallCheck(this, MemberComplianceService);

    this.$http = $http;
  }

  _createClass(MemberComplianceService, [{
    key: 'process',
    value: function process() {
      return this.$http.post('/api/compliance/process');
    }
  }, {
    key: 'getNonCompliantCompanies',
    value: function getNonCompliantCompanies() {
      return this.$http.get('/api/compliance/get_fail_list');
    }
  }, {
    key: 'getCompliantCompanies',
    value: function getCompliantCompanies() {
      return this.$http.get('/api/compliance/get_pass_list');
    }
  }]);

  return MemberComplianceService;
}();

exports.default = MemberComplianceService;


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.service.js